export default function(analytics) {
  return {
    trackJobsOverviewPageVisit(params) {
      const paramNames = {locations: 'Location', industries: 'Industry', areas: 'Area of expertise'};
      let properties = {};

      Object.keys(params).forEach(key => {
        let propertyName = paramNames[key];
        if (propertyName) {
          properties[propertyName] = params[key];
        }
      });

      analytics.trackEvent({
        action: 'Jobs Overview Page Visit',
        properties: properties
      });
    },

    trackLoadMoreJobsClicked() {
      analytics.trackEvent({action: 'Load More Jobs'});
    }
  };
}
